"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check if the whole table is selected
 * @param vTable VTable to check whether all cells are selected
 * @param selection Table selection with first cell selected and last cell selected coordinates.
 * @returns
 */
function isWholeTableSelected(vTable, selection) {
    if (!selection || !vTable.cells) {
        return false;
    }
    var firstCell = selection.firstCell, lastCell = selection.lastCell;
    var rowsLength = vTable.cells.length - 1;
    var colIndex = vTable.cells[rowsLength].length - 1;
    var firstX = firstCell.x;
    var firstY = firstCell.y;
    var lastX = lastCell.x;
    var lastY = lastCell.y;
    return firstX == 0 && firstY == 0 && lastX == colIndex && lastY == rowsLength;
}
exports.default = isWholeTableSelected;
//# sourceMappingURL=isWholeTableSelected.js.map